import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {changePhoneNumber, changeReceiverName, transitionToAuto, getInitialState} from '@web/slices/receiverInfo/slice'

import type {ReceiverInfoReducers, MakeCreateSliceOptions} from './interfaces'
import type {ReceiverInfoState} from '@web/slices/receiverInfo/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<ReceiverInfoState, ReceiverInfoReducers, 'receiverInfo', SliceSelectors<ReceiverInfoState>>({
        name: 'receiverInfo',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(changeReceiverName, (state, {payload}) => {
                    state.receiverName = payload
                })
                .addCase(changePhoneNumber, (state, {payload}) => {
                    state.phoneNumber = payload
                })
                .addCase(transitionToAuto, (state, {payload}) => {
                    // 사용자 휴대폰 번호가 없다면, 주문자 정보 자동 입력을 이용할 수 없음
                    state.usedAutofill = payload
                    state.phoneNumber = payload ? state.autofillPhoneNumber : ''
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.receiverInfo ?? state
            })
        },
    })
